import type { HeaderEvents } from "./HeaderEvents";

/**
 * Базовый Header всех экранов.
 */
export abstract class HeaderComponent {

    protected root!: HTMLElement;

    protected left!: HTMLElement;

    protected center!: HTMLElement;

    protected right!: HTMLElement;

    constructor(
        protected readonly events: HeaderEvents
    ) {}

    public mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "header";

        this.left =
            document.createElement("div");

        this.left.className =
            "header-left";

        this.center =
            document.createElement("div");

        this.center.className =
            "header-center";

        this.right =
            document.createElement("div");

        this.right.className =
            "header-right";

        this.build();

        this.root.appendChild(
            this.left
        );

        this.root.appendChild(
            this.center
        );

        this.root.appendChild(
            this.right
        );

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    protected abstract build(): void;

    // =====================================================

    protected setLeft(
        node: HTMLElement
    ): void {

        this.left.replaceChildren(
            node
        );

    }

    protected setCenter(
        node: HTMLElement
    ): void {

        this.center.replaceChildren(
            node
        );

    }

    protected setRight(
        node: HTMLElement
    ): void {

        this.right.replaceChildren(
            node
        );

    }

    // =====================================================

    protected createLogo(): HTMLElement {

        const logo =
            document.createElement("img");

        logo.src =
            "/img/logo.png";

        logo.className =
            "header-logo";

        return logo;

    }

    protected createIconButton(
        icon: string,
        alt: string,
        onClick: () => void
    ): HTMLElement {

        const button =
            document.createElement("button");

        button.className =
            "icon-btn";

        button.addEventListener(
            "click",
            onClick
        );

        const image =
            document.createElement("img");

        image.src =
            icon;

        image.alt =
            alt;

        button.appendChild(
            image
        );

        return button;

    }

}